import util from '@bmp-vue/core/api/util'
const controller = 'Motos'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  GetTaxa (th) {
    const tx = th.$aux.Veiculo_PercJuros.find(item => item.modeloComissao === th.model.ModeloComissao && item.cilindradas === th.model.PropostaDadosVeiculo.Cilindradas && item.zeroKM === th.model.PropostaDadosVeiculo.ZeroKM && item.prazo === th.model.Parcelas)
    tx ? th.$set(th.model, 'txSelecionada', tx.taxa) : th.$set(th.model, 'txSelecionada', 0)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * 0.2).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.Cilindradas) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_CILINDRADAS', ValorCampo: th.model.PropostaDadosVeiculo.Cilindradas }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos }) }
  },
  CarregaDiasAcrescimo (th, value) {
    if (value && !ctrl.AllowedDates(th, value)) {
      let date = new Date(value)
      date = th.$api.UI.Date.AddDay(date, 1).toISOString().substr(0, 10)
      th.$set(th.model, 'DtPrimeiroVencto', date)
      th.carregaDiasAcrescimo(date)
    }
  },
  VlrEntradaRule (th) {
    return [
      th.model.VlrEntrada <= th.model.VlrProdutoBem || 'O Valor da Entrada deve ser menor que Valor do Veículo',
      th.model.VlrEntrada >= (th.model.VlrProdutoBem * 0.2).toFixed(2) || 'O Valor da Entrada deve ser pelo menos 20% do Valor do Veículo'
    ]
  },
  VlrProdutoBemRule (th) {
    if (!th.model.PropostaDadosVeiculo.ZeroKM) {
      return [
        th.model.VlrProdutoBem <= th.model.PropostaDadosVeiculo.VlrFipe || 'O Valor do Veículo deve ser menor ou igual ao Valor da Fipe'
      ]
    }
  },
  AllowedDates (th, value) {
    if (th && value) {
      return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
    } else {
      const date = new Date(`${th} 00:00:00`)
      const dayOfWeek = date.getDay()
      const isWeekend = [0, 6].includes(dayOfWeek)
      if (!isWeekend) { return date }
    }
  },
})

export default ctrl
